// extracted by mini-css-extract-plugin
export var bodyRow = "_g2-d";
export var cardColumns = "_g2-e";
export var ellipsesOverflow = "_g2-2";
export var flatBottomCorners = "_g2-3";
export var flatTopCorners = "_g2-4";
export var headerActionsDropdown = "_g2-f";
export var headerBottomRow = "_g2-c";
export var headerTopRow = "_g2-b";
export var orderDetailsWrapper = "_g2-0";
export var orderInfoContainer = "_g2-1";
export var productDetails = "_g2-9";
export var productImage = "_g2-5";
export var responsiveTable = "_g2-8";
export var shipmentContainer = "_g2-a";
export var tableBottomLeft = "_g2-6";
export var tableBottomRight = "_g2-7";
export var trackingLink = "_g2-g";